<template>
  <div class="flex">
    <div v-if="params.data.has_all_subject">General</div>
    <div v-else-if="params.value.length < 2">
      <span
        class="all_tags_holder_block"
        style="word-break: break-word; white-space: normal"
      >
        <span
          class="tag_span"
          :style="{
            padding: '3px 0px',
          }"
        >
          <span
            style="
              line-height: 16px;
              text-overflow: ellipsis;
              min-width: 75px !important;
              overflow: hidden;
              display: inline-block;
              position: relative;
              top: 2px;
              margin-right: 5px;
            "
          >
            {{ params.data.subjects.length>0?params.data.subjects[0].subject_name:'' }}
          </span>
        </span>
      </span>
    </div>
    <div v-else-if="params.value.length > 1">
      <span
        class="all_tags_holder_block"
        style="word-break: break-word; white-space: normal"
      >
        <span
          class="tag_span"
          :style="{
            padding: '3px 0px'
          }"
        >
          <span
            style="
              line-height: 16px;
              text-overflow: ellipsis;
              min-width: 75px !important;
              overflow: hidden;
              display: inline-block;
              position: relative;
              top: 2px;
              margin-right: 5px;
            "
          >
            {{ params.data.subjects.length>0?params.data.subjects[0].subject_name:'' }} ..
          </span>
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CourseSubjectComponents',
  mounted () {
  },
  data () {
    return {}
  }
}
</script>

